import { gql } from 'graphql-request'

export const HANDLE_POPUP_BANNER = gql`
  mutation HandlePopupBanner($handlePopupBannerInput: HandlePopupBannerInput!) {
    handlePopupBanner(handlePopupBannerInput: $handlePopupBannerInput) {
      message
    }
  }
`
